import React, { useEffect, useMemo, useState, useCallback } from 'react';
import Header from '../../components/Header';
import { colors, radius, shadows, spacing } from '../../styles/theme';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8001';

/*
 * ============================================================
 * RAPORDA GÖSTERİLECEK ÜRÜNLER
 * ============================================================
 *
 * ad:
 *   Raporda görünecek isim.
 *
 * faturaAdlari:
 *   Satış faturasında bu ürüne karşılık gelebilecek isimler.
 *
 * Yeni ürün eklemek için yalnızca bu listeye ekleme yapmak yeterli.
 */
/*
const RAPOR_URUNLERI = [
  {
    ad: 'Cevapi',
    faturaAdlari: ['Cevapi'],
  },
  {
    ad: 'Pleskavica',
    faturaAdlari: ['Pleskavica','Pleskavica Köfte'],
  },
   {
     ad: 'Muhacir Ciğer Sarma',
     faturaAdlari: ['Muhacir Ciğer Sarma'],
   },
   {
     ad: 'Dana Tiftik',
     faturaAdlari: ['Dana Tiftik'],
   },
   {
     ad: 'Dana Kuşbaşı',
     faturaAdlari: ['Dana Kuşbaşı'],
   },   
   {
     ad: 'Tavuk Kelebek',
     faturaAdlari: ['Tavuk Kelebek'],
   },   
  
  {
    ad: 'Mostar',
    faturaAdlari: ['Mostar'],
  },
  {
    ad: 'Novi Pazar Cevapi',
    faturaAdlari: ['Novi Pazar Cevapi'],
  },
  {
    ad: 'Et Smash',
    faturaAdlari: [
      'Et Smash',
      'Et Smash Köftesi',
    ],
  },
  {
    ad: 'Crunchy',
    faturaAdlari: [
      'Crunchy',
      'Crunchy Köftesi',
    ],
  },
  {
    ad: 'Tenders',
    faturaAdlari: [
      'Tenders',
      'Chicken Tenders',
    ],
  },
  {
    ad: 'Tiftik Et (Kaburga)',
    faturaAdlari: [
      'Tiftik Et (Kaburga)',
      'Tiftik Et',
      'Kaburga',
    ],
  },
  {
    ad: 'Kasnak Kıyması',
    faturaAdlari: [
      'Kasnak Kıyması',
      'Kasnak Kıyma',
    ],
  },
  {
    ad: 'Kuzu Tandır',
    faturaAdlari: ['Kuzu Tandır'],
  },
  {
    ad: 'Muhacir C. Sarma',
    faturaAdlari: [
      'Muhacir C. Sarma',
      'Muhacir Sarma',
    ],
  },
  {
    ad: 'Dana Tiftik',
    faturaAdlari: [
      'Dana Tiftik',
    ],
  },
    
  {
    ad: 'Ciğer',
    faturaAdlari: [
      'Ciğer',
      'Ciger',
    ],
  },
];
*/

const RAPOR_URUNLERI = [
  { ad: 'Cevapi', faturaAdlari: ['Cevapi'] },

  {
    ad: 'Pleskavica',
    faturaAdlari: ['Pleskavica', 'Pleskavica Köfte'],
  },

  { ad: 'Mostar', faturaAdlari: ['Mostar'] },

  {
    ad: 'Novi Pazar Cevapi',
    faturaAdlari: ['Novi Pazar Cevapi'],
  },

  {
    ad: 'Muhacir Ciğer Sarma',
    faturaAdlari: [
      'Muhacir Ciğer Sarma',
      'Muhacir C. Sarma',
      'Muhacir Sarma',
    ],
  },

  { ad: 'Dana Tiftik', faturaAdlari: ['Dana Tiftik'] },

  {
    ad: 'Dana Ciğer İşlenmiş',
    faturaAdlari: [
      'Dana Ciğer(İşlenmiş)',
      'Dana Ciğer (İşlenmiş)',
      'Dana Ciğer İşlenmiş',
    ],
  },

  { ad: 'Dana Kuşbaşı', faturaAdlari: ['Dana Kuşbaşı'] },

  {
    ad: 'Tavuk Kelebek',
    faturaAdlari: [
      'Tavuk Kelebek',
      'Tavuk Kelebek/Pirzola',
    ],
  },

  {
    ad: 'Et Smash',
    faturaAdlari: ['Et Smash', 'Et Smash Köftesi'],
  },

  {
    ad: 'Crunchy',
    faturaAdlari: ['Crunchy', 'Crunchy Köftesi'],
  },

  {
    ad: 'Tenders',
    faturaAdlari: ['Tenders', 'Chicken Tenders'],
  },

  {
    ad: 'Tiftik Et (Kaburga)',
    faturaAdlari: [
      'Tiftik Et (Kaburga)',
      'Tiftik Et',
      'Kaburga',
    ],
  },

  {
    ad: 'Kasnak Kıyması',
    faturaAdlari: ['Kasnak Kıyması', 'Kasnak Kıyma'],
  },

  { ad: 'Kuzu Tandır', faturaAdlari: ['Kuzu Tandır'] },

  { ad: 'Ciğer', faturaAdlari: ['Ciğer', 'Ciger'] },
];


/*
 * Türkçe karakterleri de dikkate alarak ürün adını
 * karşılaştırmaya hazırlar.
 */
const normalize = (value) =>
  String(value || '')
    .trim()
    .toLocaleLowerCase('tr-TR')
    .replace(/\s+/g, ' ');


/*
 * Sayı gösterimi.
 * Örnek:
 * 22908 -> 22.908
 * 1250.5 -> 1.250,5
 */
const adetFmt = (value) =>
  Number(value || 0).toLocaleString('tr-TR', {
    maximumFractionDigits: 2,
  });


const cardStyle = {
  background: colors.surface,
  borderRadius: radius.lg,
  boxShadow: shadows.sm,
  border: `1px solid ${colors.border}`,
};


const inputStyle = {
  padding: '10px 12px',
  border: `1px solid ${colors.border}`,
  borderRadius: radius.sm,
  fontSize: '14px',
  background: colors.surface,
  color: colors.textPrimary,
  boxSizing: 'border-box',
};


const SatisUrunOzetPage = () => {
  const token = localStorage.getItem('access_token');

  const [cariler, setCariler] = useState([]);
  const [cariId, setCariId] = useState('');

  const [tarihBaslangic, setTarihBaslangic] = useState('');
  const [tarihBitis, setTarihBitis] = useState('');

  const [hamVeri, setHamVeri] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hata, setHata] = useState('');


  /*
   * Müşterileri getir.
   * Firma combobox'ı buradan oluşur.
   */
  useEffect(() => {
    fetch(`${API}/api/cari?tip=MUSTERI&include_inactive=true`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => (res.ok ? res.json() : []))
      .then((data) => {
        setCariler(Array.isArray(data) ? data : []);
      })
      .catch(() => {
        setCariler([]);
      });
  }, [token]);


  /*
   * Backend'deki yeni /urun-ozeti endpoint'ini çağır.
   */
  const raporuGetir = useCallback(async () => {
    setLoading(true);
    setHata('');

    try {
      const params = new URLSearchParams();

      if (cariId) {
        params.set('cari_id', cariId);
      }

      if (tarihBaslangic) {
        params.set('tarih_baslangic', tarihBaslangic);
      }

      if (tarihBitis) {
        params.set('tarih_bitis', tarihBitis);
      }

      const qs = params.toString();

      const res = await fetch(
        `${API}/api/satis-faturalari/urun-ozeti${qs ? `?${qs}` : ''}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await res.json().catch(() => []);

      if (!res.ok) {
        throw new Error(
          data?.detail || 'Rapor alınamadı.'
        );
      }

      setHamVeri(Array.isArray(data) ? data : []);
    } catch (err) {
      setHamVeri([]);
      setHata(err.message || 'Rapor alınamadı.');
    } finally {
      setLoading(false);
    }
  }, [
    token,
    cariId,
    tarihBaslangic,
    tarihBitis,
  ]);


  /*
   * Backend'den gelen ADET kayıtlarını,
   * bizim RAPOR_URUNLERI listemizle eşleştir.
   *
   * Backend KG kayıtlarını zaten göndermiyor.
   */



  /*
   * Sıfır olmayan ürünler.
   *
   * Şimdilik raporda yalnız satış bulunan ürünleri gösteriyoruz.
   */
const gorunenSatirlar = useMemo(() => {
  const gruplanmis = new Map();

  hamVeri
    .filter((satir) => !cariId || String(satir.cari_id) === String(cariId))
    .forEach((satir) => {
      const raporUrunu = RAPOR_URUNLERI.find((u) =>
        u.faturaAdlari.map(normalize).includes(normalize(satir.urun))
      );
      if (!raporUrunu) return;

      const key = normalize(raporUrunu.ad);
      const mevcut = gruplanmis.get(key) || {
        urun: raporUrunu.ad, toplamKg: 0, toplamAdet: 0,
        adetDonusumuVar: false, kgAdetleri: new Set(), kalemSayisi: 0, faturaNolari: new Set(),
      };

      mevcut.toplamKg += Number(satir.toplam_kg) || 0;
      if (satir.toplam_adet !== null && satir.toplam_adet !== undefined) {
        mevcut.toplamAdet += Number(satir.toplam_adet) || 0;
        mevcut.adetDonusumuVar = true;
      }
      if (satir.kg_adet !== null && satir.kg_adet !== undefined && Number(satir.kg_adet) > 0) {
        mevcut.kgAdetleri.add(Number(satir.kg_adet));
      }
      mevcut.kalemSayisi += Number(satir.kalem_sayisi) || 0;
      (Array.isArray(satir.fatura_nolari) ? satir.fatura_nolari : [])
        .forEach((no) => mevcut.faturaNolari.add(no));
      gruplanmis.set(key, mevcut);
    });

  return Array.from(gruplanmis.values())
    .map((satir) => ({
      urun: satir.urun,
      toplamKg: satir.toplamKg,
      toplamAdet: satir.adetDonusumuVar ? satir.toplamAdet : null,
      kgAdet: satir.kgAdetleri.size === 1 ? Array.from(satir.kgAdetleri)[0] : null,
      donusumCoklu: satir.kgAdetleri.size > 1,
      faturaSayisi: satir.faturaNolari.size,
      kalemSayisi: satir.kalemSayisi,
      faturaNolari: Array.from(satir.faturaNolari).sort(),
    }))
    .sort((a, b) => a.urun.localeCompare(b.urun, 'tr'));
}, [hamVeri, cariId]);


  const toplamAdet = useMemo(
    () => gorunenSatirlar.reduce(
      (toplam, satir) => toplam + (satir.toplamAdet || 0),
      0
    ),
    [gorunenSatirlar]
  );


  const seciliFirma =
    cariId
      ? cariler.find(
          (c) => String(c.id) === String(cariId)
        )?.unvan || ''
      : 'Tüm Firmalar';


  /*
   * CSV indir.
   */
  const csvIndir = () => {
    if (gorunenSatirlar.length === 0) {
      return;
    }

    const csvEscape = (value) =>
      `"${String(value ?? '').replace(/"/g, '""')}"`;

    const satirlar = [
      [
        'Firma',
        'Başlangıç Tarihi',
        'Bitiş Tarihi',
        'Ürün',
        'KG',
        'Birim Dönüşüm (KG/Adet)',
        'Adet',
        'Fatura Sayısı',
        'Kalem Sayısı',
        'Fatura No',
      ],
      ...gorunenSatirlar.map((satir) => [
        seciliFirma,
        tarihBaslangic || '',
        tarihBitis || '',
        satir.urun,
        satir.toplamKg,
        satir.donusumCoklu ? 'Çeşitli' : (satir.kgAdet ?? ''),
        satir.toplamAdet ?? '',
        satir.faturaSayisi,
        satir.kalemSayisi,
        satir.faturaNolari.join(', '),
      ]),
    ];

    /*
     * Excel'in Türkçe karakterleri düzgün açması için BOM.
     * Ayırıcı olarak ; kullanıyoruz.
     */
    const csv =
      '\uFEFF' +
      satirlar
        .map((satir) =>
          satir.map(csvEscape).join(';')
        )
        .join('\n');

    const blob = new Blob(
      [csv],
      {
        type: 'text/csv;charset=utf-8;',
      }
    );

    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');

    const firmaDosyaAdi = seciliFirma
      .replace(/[^a-zA-Z0-9ğüşöçıİĞÜŞÖÇ]+/g, '_')
      .replace(/^_+|_+$/g, '');

    a.href = url;
    a.download =
      `satis_urun_ozeti_${firmaDosyaAdi || 'tum_firmalar'}_${tarihBaslangic || 'baslangic'}_${tarihBitis || 'bitis'}.csv`;

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    URL.revokeObjectURL(url);
  };


  return (
    <div>
      <Header title="Satış Ürün Özeti" />

      <div
        style={{
          padding: spacing.lg,
          background: colors.background,
          minHeight: 'calc(100vh - 60px)',
        }}
      >

        {/* Filtreler */}
        <div
          style={{
            ...cardStyle,
            padding: spacing.base,
            marginBottom: spacing.lg,
          }}
        >
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: spacing.md,
              alignItems: 'end',
            }}
          >

            {/* Firma */}
            <div style={{ minWidth: '280px' }}>
              <div
                style={{
                  fontSize: '12px',
                  fontWeight: 700,
                  marginBottom: '5px',
                  color: colors.textSecondary,
                }}
              >
                Firma
              </div>

              <select
                value={cariId}
                onChange={(e) => setCariId(e.target.value)}
                style={{
                  ...inputStyle,
                  width: '100%',
                  cursor: 'pointer',
                }}
              >
                <option value="">Tüm Firmalar</option>

                {cariler
                  .slice()
                  .sort((a, b) =>
                    String(a.unvan || '').localeCompare(
                      String(b.unvan || ''),
                      'tr'
                    )
                  )
                  .map((c) => (
                    <option key={c.id} value={c.id}>
                      {c.unvan}
                    </option>
                  ))}
              </select>
            </div>


            {/* Başlangıç */}
            <div>
              <div
                style={{
                  fontSize: '12px',
                  fontWeight: 700,
                  marginBottom: '5px',
                  color: colors.textSecondary,
                }}
              >
                Başlangıç Tarihi
              </div>

              <input
                type="date"
                value={tarihBaslangic}
                onChange={(e) =>
                  setTarihBaslangic(e.target.value)
                }
                style={inputStyle}
              />
            </div>


            {/* Bitiş */}
            <div>
              <div
                style={{
                  fontSize: '12px',
                  fontWeight: 700,
                  marginBottom: '5px',
                  color: colors.textSecondary,
                }}
              >
                Bitiş Tarihi
              </div>

              <input
                type="date"
                value={tarihBitis}
                onChange={(e) =>
                  setTarihBitis(e.target.value)
                }
                style={inputStyle}
              />
            </div>


            {/* Raporu getir */}
            <button
              onClick={raporuGetir}
              disabled={loading}
              style={{
                padding: '10px 18px',
                border: 'none',
                borderRadius: radius.sm,
                background: colors.primary,
                color: 'white',
                cursor: loading ? 'wait' : 'pointer',
                fontWeight: 700,
                fontSize: '14px',
              }}
            >
              {loading ? 'Yükleniyor…' : 'Raporu Getir'}
            </button>


            {/* CSV */}
            <button
              onClick={csvIndir}
              disabled={gorunenSatirlar.length === 0}
              style={{
                padding: '10px 18px',
                borderRadius: radius.sm,
                border: `1px solid ${colors.border}`,
                background: colors.surface,
                color: colors.textPrimary,
                cursor:
                  gorunenSatirlar.length === 0
                    ? 'not-allowed'
                    : 'pointer',
                fontWeight: 700,
                fontSize: '14px',
                opacity:
                  gorunenSatirlar.length === 0
                    ? 0.5
                    : 1,
              }}
            >
              CSV İndir
            </button>

          </div>
        </div>


        {/* Hata */}
        {hata && (
          <div
            style={{
              padding: '12px 16px',
              marginBottom: spacing.lg,
              background: '#fdecec',
              border: '1px solid #efb6b6',
              borderRadius: radius.sm,
              color: '#b42318',
            }}
          >
            {hata}
          </div>
        )}


        {/* Özet */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns:
              'repeat(auto-fit, minmax(210px, 1fr))',
            gap: spacing.base,
            marginBottom: spacing.lg,
          }}
        >
          <div style={{ ...cardStyle, padding: '18px' }}>
            <div
              style={{
                color: colors.textSecondary,
                fontSize: '12px',
                fontWeight: 700,
              }}
            >
              ÜRÜN ÇEŞİDİ
            </div>

            <div
              style={{
                fontSize: '28px',
                fontWeight: 800,
                marginTop: '5px',
              }}
            >
              {gorunenSatirlar.length}
            </div>
          </div>

          <div style={{ ...cardStyle, padding: '18px' }}>
            <div
              style={{
                color: colors.textSecondary,
                fontSize: '12px',
                fontWeight: 700,
              }}
            >
              TOPLAM ADET
            </div>

            <div
              style={{
                fontSize: '28px',
                fontWeight: 800,
                marginTop: '5px',
              }}
            >
              {adetFmt(toplamAdet)}
            </div>
          </div>
        </div>


        {/* Tablo */}
        <div
          style={{
            ...cardStyle,
            overflow: 'hidden',
          }}
        >
          <div style={{ overflowX: 'auto' }}>
            <table
              style={{
                width: '100%',
                borderCollapse: 'collapse',
              }}
            >
              <thead>
                <tr
                  style={{
                    background: colors.backgroundAlt,
                    color: colors.textSecondary,
                    fontSize: '12px',
                    textTransform: 'uppercase',
                  }}
                >
                  <th
                    style={{
                      padding: '11px 14px',
                      textAlign: 'left',
                    }}
                  >
                    Ürün
                  </th>
                  
                  <th style={{ textAlign: 'right' }}>KG</th>
                  <th style={{ padding: '11px 14px', textAlign: 'right' }}>Birim Dönüşüm</th>

                  <th
                    style={{
                      padding: '11px 14px',
                      textAlign: 'right',
                    }}
                  >
                    Toplam Adet
                  </th>
                  <th style={{ padding: '11px 14px', textAlign: 'right' }}>Fatura</th>
                  <th style={{ padding: '11px 14px', textAlign: 'right' }}>Kalem</th>
                </tr>
              </thead>

              <tbody>
                {gorunenSatirlar.map((satir) => (
                  <tr
                    key={satir.urun}
                    style={{
                      borderTop:
                        `1px solid ${colors.borderLight}`,
                    }}
                  >
                    <td
                      style={{
                        padding: '11px 14px',
                        fontWeight: 600,
                        color: colors.textPrimary,
                      }}
                    >
                      {satir.urun}
                    </td>
                    <td style={{ textAlign: 'right' }}>
                      {adetFmt(satir.toplamKg)}
                    </td>
                    <td style={{ padding: '11px 14px', textAlign: 'right' }}>
                      {satir.donusumCoklu ? 'Çeşitli' : (satir.kgAdet === null ? '—' : `${adetFmt(satir.kgAdet)} KG/Adet`)}
                    </td>
                    <td
                      style={{
                        padding: '11px 14px',
                        textAlign: 'right',
                        fontWeight: 700,
                        color: colors.textPrimary,
                      }}
                    >
                      {satir.toplamAdet === null ? '—' : adetFmt(satir.toplamAdet)}
                    </td>
                    <td style={{ padding: '11px 14px', textAlign: 'right' }} title={satir.faturaNolari.join(', ')}>
                      {satir.faturaSayisi}
                    </td>
                    <td style={{ padding: '11px 14px', textAlign: 'right' }}>
                      {satir.kalemSayisi}
                    </td>
                  </tr>
                ))}

                {!loading &&
                  gorunenSatirlar.length === 0 && (
                    <tr>
                      <td
                        colSpan={6}
                        style={{
                          padding: '40px',
                          textAlign: 'center',
                          color: colors.textTertiary,
                        }}
                      >
                        Seçilen kriterlerde raporlanacak
                        ürün bulunamadı.
                      </td>
                    </tr>
                  )}
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>
  );
};

export default SatisUrunOzetPage;